import { Link2, Coffee } from 'lucide-react'

const LINKEDIN = 'https://www.linkedin.com/in/mindful-abhay/'
const BUYMECOFFEE = 'https://buymeacoffee.com/abhaypratapsingh'

export function CreatorLinks({ variant = 'default' }: { variant?: 'default' | 'compact' | 'footer' | 'receipt' }) {
  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-2 text-xs">
        <a href={LINKEDIN} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 hover:text-[#c9a227] transition-colors">
          <Link2 size={13} /> LinkedIn
        </a>
        <a href={BUYMECOFFEE} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 hover:text-[#c9a227] transition-colors">
          <Coffee size={13} /> Buy me a coffee
        </a>
      </div>
    )
  }
  if (variant === 'footer') {
    return (
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-[#6b7280]">
        <span>Crafted with care by Abhay Pratap Singh</span>
        <span className="text-[#2a3146]">•</span>
        <a href={LINKEDIN} target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a227] transition-colors">LinkedIn</a>
        <a href={BUYMECOFFEE} target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a227] transition-colors">Buy me a coffee</a>
      </div>
    )
  }
  if (variant === 'receipt') {
    return (
      <div className="text-[10px] text-[#555] flex items-center gap-x-3">
        <span>Instrument by Abhay Pratap Singh</span>
        <a href={LINKEDIN} target="_blank" rel="noopener noreferrer" className="hover:underline">linkedin.com/in/mindful-abhay</a>
        <a href={BUYMECOFFEE} target="_blank" rel="noopener noreferrer" className="hover:underline">buymeacoffee.com/abhaypratapsingh</a>
      </div>
    )
  }
  return (
    <div className="flex flex-wrap items-center gap-3 text-sm">
      <a href={LINKEDIN} target="_blank" rel="noopener noreferrer" className="btn-ghost flex items-center gap-1.5 px-3 py-1 text-xs">
        <Link2 size={14} /> LinkedIn
      </a>
      <a href={BUYMECOFFEE} target="_blank" rel="noopener noreferrer" className="btn-ghost flex items-center gap-1.5 px-3 py-1 text-xs border-[#c9a227] text-[#c9a227] hover:bg-[#c9a227]/10">
        <Coffee size={14} /> Buy me a coffee
      </a>
    </div>
  )
}
